module.exports = __webpack_public_path__ + "img/dcom05.e23d8194.png";